import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import sample from "../assets/sampleimage.png";

const Homeslider = () => {
  const [navSize, setNavSize] = useState(
    window.innerWidth >= 992 ? "40px" : "20px"
  );

  useEffect(() => {
    const handleResize = () => {
      setNavSize(window.innerWidth >= 992 ? "40px" : "20px");
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div style={{ width: "100%", margin: "0 auto" }}>
      <Swiper
        slidesPerView={1}
        loop
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        modules={[Pagination, Autoplay, Navigation]}
        style={{
          "--swiper-navigation-size": navSize,
          "--swiper-navigation-color": "#fff"
        }}
      >
        <SwiperSlide>
          <img src={sample} alt="Banner" className="img-fluid w-100" />
        </SwiperSlide>

        <SwiperSlide>
          <img src={sample} alt="Banner" className="img-fluid w-100" />
        </SwiperSlide>

        <SwiperSlide>
          <img src={sample} alt="Banner" className="img-fluid w-100" />
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default Homeslider;
